const T = require("react").PropTypes;
const Config = require("../../Config.js");

/**
 * Specifies metadata for store budget uploads.
 * 
 * Type gives us a shape to use in validating data passed to the component.
 * 
 * GetSpecData() generates a "Data" object for a MetadataSpec.
 */
const PCard = {
    // Factory method
    GetSpecData() {
        const spec = {
            Targets: {
                Loading: false,
                Loaded: false,
                Data: [],
                Error: null
            },
            Target: null,
            IsComplete: true,
            Arg: null
        };

        return spec;
    },
    // This should mirror the spec type.
    Type: T.shape({
        Targets: T.shape({
            Loading: T.bool,
            Loaded: T.bool,
            Data: T.arrayOf(
                T.shape({
                    Target: T.string,
                    Description: T.string
                })),
            Error: T.object
        }),
        Target: T.string
    })
};

module.exports = PCard;


// WEBPACK FOOTER //
// ./src/types/metadata/PCard.js